const table = $('.js-detail-table-block-table'),
      container = $('.js-detail-table-block-container');
const scrollTable = () => {
    container.jScrollPane({
        contentWidth: 0,
        showArrows: false,
        scrollbarWidth: 156,
        horizontalDragMinWidth: 156,
        horizontalDragMaxWidth: 156
    });
}
const resizeSrollTalbe = (block) => {
    if (block.hasClass('jspScrollable')) {
        block.jScrollPane().data('jsp').reinitialise();
    }
}
$(window).resize(function() {
    resizeSrollTalbe($('.js-detail-table-block-container'));
});
scrollTable();
$(document).on('click', '.js-tabs-btn', function(e) {
    e.preventDefault();
    $('.js-tabs-tab').removeClass('current');
    $(`.js-tabs-tab[data-id="${$(this).data('id')}"]`).addClass('current');
    location.hash = $(this).data('id');

    $('.js-tabs-btn').removeClass('current');
    $(this).addClass('current');
    
    if ($(`.js-tabs-tab[data-id="${$(this).data('id')}"]`).hasClass('js-tab-table')) {
        scrollTable();
    }
});
$(document).on('click', '.js-tabs-recomendation-tab-btn', function (e) {
    e.preventDefault();
    $('.js-tabs-recomendation-tab').removeClass('current');
    $(`.js-tabs-recomendation-tab[data-id="${$(this).data('id')}"]`).addClass('current');

    $('.js-tabs-recomendation-tab-btn').removeClass('current');
    $(this).addClass('current');

});